goog.provide("shadow.js.shim.module$dayjs$locale$sv");
goog.provide("module$shadow_js_shim_module$dayjs$locale$sv");
shadow.js.shim.module$dayjs$locale$sv = shadow.js.nativeProvides["dayjs/locale/sv"] = require("dayjs/locale/sv");
module$shadow_js_shim_module$dayjs$locale$sv.default = shadow.js.shim.module$dayjs$locale$sv;
